<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Logs</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>Fecha y hora</th>
                                <th>Error</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(log, index) in logs" :key="index">
                                <td>{{ log.created_at }}</td>
                                <td>{{ log.error }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="reprocesar" class="btn-success btn--text" type="button">
                <i class="fa fa-refresh"></i><span>Re-procesar</span>
            </button>
            <button @click="$emit('cerrar')" class="btn-danger btn--text" type="button">
                <i class="fa fa-ban"></i><span>Cerrar</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        path : {
            type : String,
            required : false,
            default : ''
        }
    },
    mounted : function () {
        this.cargarLogs();
    },
    data : function () {
        return {
            logs : []
        };
    },
    methods : {
        reprocesar : function () {
            let that = this;
            swal({
                title: '¿Desea re-procesar el fichero seleccionado?',
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText : 'Cancelar'
                }).then((result) => {
                    if (result.value) {
                        axios.post(url + '/logs', {
                            path : this.path
                        }).then(function () {
                            swal('El fichero fue mandado a re-procesamiento.', 'Realizado', 'success');
                            that.$emit('procesado');
                        }).catch(function () {
                            swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                        });
                    }
                });
        },
        cargarLogs : function () {
            let that = this;
            axios.get(url + '/logs', {
                params : {
                    path : this.path
                }
            }).then(function (response) {
                that.logs = response.data;
            });
        }
    }    
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ecas-coparn/LogNoProcesados.vue